import React, { Fragment } from "react";
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory from 'react-bootstrap-table2-filter';
import cellEditFactory from 'react-bootstrap-table2-editor';
import ToolkitProvider, { Search, CSVExport } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';

import './tablaFiltro.css';

const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
        Mostrando {from} a {to} de {size} Resultados
    </span>
);

const { ExportCSVButton } = CSVExport;

class grid extends React.Component {
    state = {
        selected: []
    }

    calculasizePerPageList = (cantidad) => {
        let lista = [];
        if (cantidad > 10 && cantidad <= 20) {
            lista = [{ text: '10', value: 10 }, { text: 'Todo', value: cantidad }];
            return lista;
        }

        if (cantidad > 20 && cantidad <= 30) {
            lista = [
                { text: '10', value: 10 },
                { text: '20', value: 20 },
                { text: 'Todo', value: cantidad }
            ];
            return lista;
        }

        if (cantidad > 30 && cantidad <= 50) {
            lista = [
                { text: '10', value: 10 },
                { text: '20', value: 20 },
                { text: '30', value: 30 },
                { text: 'Todo', value: cantidad }
            ];
            return lista;
        }

        if (cantidad > 50) {
            lista = [
                { text: '10', value: 10 },
                { text: '20', value: 20 },
                { text: '50', value: 50 },
                { text: '100', value: 100 },
                { text: 'Todo', value: cantidad }
            ];
            return lista;
        }
    }

    handleOnSelect = (row, isSelect) => {
        if (isSelect) {
            this.setState(() => ({
                selected: [row[this.props.keyField]]
            }));
        } else {
            this.setState(() => ({
                selected: []
            }));
        }
        this.props.selectRow.onSelect(row, isSelect);
    }

    render() {
        const { columnas, datos, keyField, modo, rowEvents, rowStyle, botones, busqueda, ingresarDetalle,
            eliminarDetalle, modificarDetalle, rowClasses, borrar, paginaActual } = this.props;

        let selectRow = { ...this.props.selectRow };
        selectRow.selected = this.state.selected;
        selectRow.onSelect = this.handleOnSelect;

        const { SearchBar } = Search;
        const buscar = busqueda ? { display: 'unset' } : { display: 'none' };
        const clase = "btn btn-sm pull-right flipInX animated";
        const iclase = "fa fa-file-excel-o";
        const botonera = botones ? { display: 'unset', float: "right" } : { display: 'none' };
        const _size = datos ? datos.length : 0;
        const _sizePerPageList = this.calculasizePerPageList(_size);

        let optPaginacion = {};

        if (borrar) {
            optPaginacion = {
                //custom: true,
                paginationSize: 10,
                pageStartIndex: 1,
                alwaysShowAllBtns: true, // Always show next and previous button
                withFirstAndLast: true, // Hide the going to First and Last page button
                hideSizePerPage: false, // Hide the sizePerPage dropdown always
                hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
                firstPageText: "Primero",
                prePageText: "Anterior",
                nextPageText: "Siguiente",
                lastPageText: "Último",
                nextPageTitle: "Primera Página",
                prePageTitle: "Pre page",
                firstPageTitle: "Siguiente Página",
                lastPageTitle: "Última Página",
                showTotal: true,
                paginationTotalRenderer: customTotal,
                sizePerPageList: _sizePerPageList,
                variation: "dropup",
                dataSize: _size,
                page: 1,
                onPageChange: this.props.onPageChange,
                onSizePerPageChange: this.props.onSizePerPageChange
            };
        } else {
            optPaginacion = {
                //custom: true,
                paginationSize: 10,
                pageStartIndex: 1,
                alwaysShowAllBtns: true, // Always show next and previous button
                withFirstAndLast: true, // Hide the going to First and Last page button
                hideSizePerPage: false, // Hide the sizePerPage dropdown always
                hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
                firstPageText: "Primero",
                prePageText: "Anterior",
                nextPageText: "Siguiente",
                lastPageText: "Último",
                nextPageTitle: "Primera Página",
                prePageTitle: "Pre page",
                firstPageTitle: "Siguiente Página",
                lastPageTitle: "Última Página",
                showTotal: true,
                paginationTotalRenderer: customTotal,
                sizePerPageList: _sizePerPageList,
                variation: "dropup",
                dataSize: _size,
                onPageChange: this.props.onPageChange,
                onSizePerPageChange: this.props.onSizePerPageChange
            };
        }

        if (paginaActual) {
            optPaginacion.page = paginaActual;
        }

        const BotonDet = (props) => {

            const _Agregar = !botones || !botones[0] ? 'Agregar' : botones[0].tooltip;
            const _Eliminar = !botones || !botones[1] ? 'Eliminar' : botones[1].tooltip;
            const _Modificar = !botones || !botones[2] ? 'Modificar' : botones[2].tooltip;

            const botoneraAgr = !botones || !botones[0] ? { display: 'none' } : { display: 'unset', float: "right" };
            const botoneraEli = !botones || !botones[1] ? { display: 'none' } : { display: 'unset', float: "right" };
            const botoneraMod = !botones || !botones[2] ? { display: 'none' } : { display: 'unset', float: "right" };

            const onClickAgragarDet = () => {
                ingresarDetalle(props.onSearch);
                props.onSearch('0');
                props.onSearch('');
            }

            const onClickEliminarDet = () => {
                eliminarDetalle();
                props.onSearch('0');
                props.onSearch('');
            }

            const onClickModificarDet = () => {
                modificarDetalle(props.onSearch);
                props.onSearch('0');
                props.onSearch('');
            }

            return (
                <Fragment>
                    <div style={botoneraEli} key={'1r'} className="tooltip2"><span className={'tooltiptext2'}>{_Eliminar}</span>
                        <a key={'1r'} id={'btnEliminarDet'} href="#" type="button" className={'btn btn-sm pull-right flipInX animated'} onClick={onClickEliminarDet}><i className={'fa fa-trash'}></i>{''}</a>
                    </div>
                    <div style={botoneraAgr} key={'1m'} className="tooltip2"><span className={'tooltiptext2'}>{_Agregar}</span>
                        <a key={'1m'} id={'btnAgragarDet'} href="#" type="button" className={'btn btn-sm pull-right flipInX animated'} onClick={onClickAgragarDet}><i className={'fa fa-plus'}></i>{''}</a>
                    </div>
                    <div style={botoneraMod} key={'1md'} className="tooltip2"><span className={'tooltiptext2'}>{_Modificar}</span>
                        <a key={'1m'} id={'btnModificarDet'} href="#" type="button" className={'btn btn-sm pull-right flipInX animated'} onClick={onClickModificarDet}><i className={'fa fa-pencil'}></i>{''}</a>
                    </div>

                </Fragment>
            );
        }

        return (
            <ToolkitProvider
                keyField={keyField}
                data={datos}
                columns={columnas}
                search
            >
                {
                    props => (
                        <div>
                            <div style={buscar} className='row text-right'>
                                <div className={"col"} >
                                    <div style={{ float: "left" }}>
                                        <ExportCSVButton {...props.csvProps} className={clase}  >
                                            <i className={iclase} ></i>
                                        </ExportCSVButton>
                                    </div>
                                    <div className="col col-3 text-right">
                                        <SearchBar {...props.searchProps} placeholder="Buscar" />
                                    </div>
                                    <div style={botonera}>
                                        <BotonDet {...props.searchProps} />
                                    </div>
                                </div>
                            </div>
                            <PaginationProvider
                                pagination={paginationFactory(optPaginacion)}
                            >
                                {
                                    ({
                                        paginationProps,
                                        paginationTableProps
                                    }) => (
                                        <div>
                                            <div className='table-responsive'>
                                                <BootstrapTable
                                                    {...props.baseProps}
                                                    {...paginationTableProps}
                                                    filter={filterFactory()}
                                                    cellEdit={cellEditFactory(modo)}
                                                    striped={false}
                                                    hover={true}
                                                    condensed={false}
                                                    rowEvents={rowEvents}
                                                    selectRow={selectRow}
                                                    rowClasses={rowClasses}
                                                    noDataIndication={'No hay datos que mostrar'}
                                                    insertRow={true}
                                                    rowStyle={rowStyle}
                                                />
                                            </div>
                                        </div>
                                    )
                                }
                            </PaginationProvider>

                        </div>
                    )
                }
            </ToolkitProvider>
        )
    }
}

export default grid;